/**
 * Floating Chatbot Button Component
 * 
 * Displays a floating button that opens the chatbot overlay
 * Available on all screens including before login
 */

import React, { forwardRef } from 'react';
import './ChatbotButton.css';
import { AssistantIcon } from './chatbot/AssistantIcon';

interface ChatbotButtonProps {
  onClick: () => void;
  isOpen?: boolean;
}

export const ChatbotButton = forwardRef<HTMLButtonElement, ChatbotButtonProps>(
  ({ onClick, isOpen = false }, ref) => {
    return (
      <button
        ref={ref}
        className={`chatbot-floating-btn ${isOpen ? 'open' : ''}`}
        onClick={onClick}
        aria-label={isOpen ? "Close AI assistant" : "Open AI assistant"}
        aria-expanded={isOpen}
        aria-haspopup="dialog"
        type="button"
      >
        <span className="chatbot-btn-icon" aria-hidden="true">
          <AssistantIcon width={56} height={56} />
        </span>
        {!isOpen && <span className="chatbot-btn-pulse" aria-hidden="true"></span>}
      </button>
    );
  }
);

ChatbotButton.displayName = 'ChatbotButton';
